import React, { useEffect, useState } from "react";
import api from "../services/api";

function EditStudent({ studentId, setPage }) {

const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [email,setEmail] = useState("");
const [mobile,setMobile] = useState("");
const [status,setStatus] = useState("active");

const [productAccess,setProductAccess] = useState({
  lms:true,
  live:false
});
const [productAccessLoading,setProductAccessLoading] = useState(true);

const [batches,setBatches] = useState([""]);

const [courses,setCourses] = useState([]);
const [modules,setModules] = useState([]);
const [password, setPassword] = useState("");

const [courseAccess,setCourseAccess] = useState([]);
const [selectedIndex,setSelectedIndex] = useState(0);
const [showPassword, setShowPassword] = useState(false);

useEffect(()=>{
loadStudent();
loadCourses();
loadModules();
loadStudentAccess();
loadProductAccess();
},[]);

/* LOAD STUDENT */

const loadStudent = async ()=>{

try{

const res = await api.get("/students");

const student = res.data.data.find(s=>s.id===studentId);

if(!student) return;

//setName([student.first_name,student.last_name].filter(Boolean).join(" "));
setFirstName(student.first_name || "");
setLastName(student.last_name || "");
setEmail(student.email || "");
setMobile(student.mobile || "");
setStatus(student.status || "active");

if(student.batches){

if(Array.isArray(student.batches)){
setBatches(student.batches);
}else{
setBatches(student.batches.split(","));
}

}else{

setBatches([""]);

}

}catch(err){

console.log("Student load error",err);

}

};

/* LOAD COURSES */

const loadCourses = async ()=>{

try{

const res = await api.get("/courses");
setCourses(res.data.data || []);

}catch(err){

console.log(err);

}

};

/* LOAD MODULES */

const loadModules = async ()=>{

try{

const res = await api.get("/modules");
setModules(res.data.data || []);

}catch(err){

console.log(err);

}

};

/* LOAD ACCESS */

const loadStudentAccess = async ()=>{

try{

const res = await api.get(`/students/${studentId}/access`);

const access = res.data.data.map(a=>({

course_id:a.course_id,
access_type:a.access_type,
module_ids:a.modules ? a.modules.map(m=>m.id) : [],
video_source: a.video_source ?? "maaz",
start_date: a.start_date ? a.start_date.substring(0, 10) : "",
end_date: a.end_date ? a.end_date.substring(0, 10) : "",
status:a.status || "active",
isNew: false

}));

setCourseAccess(access);

}catch(err){

console.log(err);

}

};

/* LOAD PRODUCT ACCESS */

const loadProductAccess = async ()=>{

try{

const res = await api.get(`/students/${studentId}/products`);
const products = res?.data?.data?.products || { lms:true, live:false };

setProductAccess({
  lms:Boolean(products.lms),
  live:Boolean(products.live)
});

}catch(err){

console.log("Product access load error",err);
// Safe fallback for existing LMS students.
setProductAccess({lms:true,live:false});

}finally{
setProductAccessLoading(false);
}

};

/* BATCH HANDLERS */

const updateBatch = (index,value)=>{

const updated=[...batches];
updated[index]=value;
setBatches(updated);

};

const addBatch = ()=>{
setBatches([...batches,""]);
};

const removeBatch = (index)=>{
const updated=batches.filter((_,i)=>i!==index);
setBatches(updated);
};

/* COURSE ACCESS */

const addCourseAccess = ()=>{

setCourseAccess([

...courseAccess,
{
course_id:"",
access_type:"full",
module_ids:[],
video_source:"maaz",
start_date:"",
end_date:"",
status:"active",
isNew: true
}

]);

setSelectedIndex(courseAccess.length);

};

const updateCourseAccess = (index, field, value) => {
  const updated = [...courseAccess];

  // 🔥 FIX: Ensure object exists
  if (!updated[index]) {
    updated[index] = {};
  }

  updated[index][field] = value;

  setCourseAccess(updated);
};

const toggleModule=(moduleId)=>{

const updated=[...courseAccess];

const selected = updated[selectedIndex].module_ids || [];

if(selected.includes(moduleId)){

updated[selectedIndex].module_ids = selected.filter(id=>id!==moduleId);

}else{

updated[selectedIndex].module_ids = [...selected,moduleId];

}

setCourseAccess(updated);

};

const getModulesForCourse=(courseId)=>{
return modules.filter(m=>m.course_id===courseId);
};

  const removeCourseAccess = (index) => {
  const updated = courseAccess.filter((_, i) => i !== index);
  setCourseAccess(updated);

  // 🔥 Important: prevent crash if last item removed
  setSelectedIndex(prev => {
    if (updated.length === 0) return 0;
    if (prev >= updated.length) return updated.length - 1;
    return prev;
  });
};

/* SAVE */

const saveStudent = async () => {

  try {

    // ✅ REQUIRED VALIDATIONS
    if (!firstName || !email) {
      alert("First Name and Email are required");
      return;
    }

    // ✅ BATCH VALIDATION
    if (!batches.length || !batches.some(b => b.trim() !== "")) {
      alert("Batch is required");
      return;
    }

    // 🔥 DATE VALIDATION (ADD HERE)
    for (let i = 0; i < courseAccess.length; i++) {
      const c = courseAccess[i];

      if (!c.course_id) {
        alert("Please select course");
        return;
      }

      if (!c.start_date || !c.end_date) {
        alert("Start date and End date are required for all courses");
        return;
      }

      if (new Date(c.start_date) > new Date(c.end_date)) {
        alert("Start date cannot be greater than End date");
        return;
      }
    }


    // ✅ FIX: sanitize video_source ONLY
    const cleanedCourses = courseAccess.map(c => ({
  ...c,
  start_date: c.start_date || null,
  end_date: c.end_date || null,
  video_source:
    (c.video_source || "").toLowerCase().includes("bunny")
      ? "bunny"
      : "maaz"
}));

    await api.put(`/students/${studentId}`, {

      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email: email.toLowerCase().trim(),
      mobile,
      status,
      batches: batches.filter(b => b.trim() !== ""),
      product_access:{
        lms:Boolean(productAccess.lms),
        live:Boolean(productAccess.live)
      },
      courses: cleanedCourses,
      ...(password ? { password } : {})

    });

    alert("Student updated successfully");
    setPage({ page: "students" });

  } catch (err) {

    console.log(err);

    const msg =
      err?.response?.data?.message || "Failed to update student";

    alert(msg);
  }

};
  
const currentAccess = courseAccess[selectedIndex] || {};

return(

<div style={{padding:"30px",maxWidth:"950px"}}>

<h2 style={{marginBottom:"25px"}}>Edit Student</h2>

{/* BASIC INFO */}

<div style={card}>

  <input
  value={firstName}
  placeholder="First Name"
  onChange={(e)=>setFirstName(e.target.value)}
  style={input}
/>

<input
  value={lastName}
  placeholder="Last Name"
  onChange={(e)=>setLastName(e.target.value)}
  style={input}
/>

<input
value={email}
placeholder="Email"
autoComplete="off"
name="student_email_edit"
onChange={(e)=>setEmail(e.target.value)}
style={input}
/>

<input
value={mobile}
placeholder="Mobile"
onChange={(e)=>setMobile(e.target.value)}
style={input}
/>

<select
value={status}
onChange={(e)=>setStatus(e.target.value)}
style={input}
>

<option value="active">Active</option>
<option value="inactive">Inactive</option>
</select>

<div style={{ position: "relative", marginBottom: "16px" }}>

  <label style={{ fontSize: "13px", fontWeight: "500" }}>
    New Password
  </label>

  <input
    type={showPassword ? "text" : "password"}
    value={password}
    placeholder="Enter new password"
    autoComplete="new-password"
    name="student_new_password"
    onChange={(e) => setPassword(e.target.value)}
    style={{
      width: "90%",
      padding: "10px 60px 10px 10px",
      border: "1px solid #ddd",
      borderRadius: "6px",
      marginTop: "6px"
    }}
  />
{/* SHOW / HIDE */}
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",              // 🔥 center vertically
      transform: "translateY(-20%)", // 🔥 perfect alignment
      border: "none",
      background: "transparent",
      cursor: "pointer",
      fontSize: "12px",
      color: "#3b82f6"
    }}
  >
 
    {showPassword ? "Hide" : "Show"}
  </button>

  <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>
    Leave blank if you don’t want to change password
  </div>

</div>

</div>

{/* PRODUCT ACCESS */}

<div style={card}>

<h3 style={{marginTop:0,marginBottom:"8px"}}>Product Access</h3>
<p style={{marginTop:0,color:"#667085",fontSize:"13px",marginBottom:"18px"}}>
Manage which MaAz products this student can open using the same account.
</p>

{productAccessLoading ? (
  <div style={{fontSize:"13px",color:"#667085"}}>Loading product access...</div>
) : (
  <div style={productAccessGrid}>

    <label style={{...productAccessOption,...(productAccess.lms ? productAccessOptionActive : {})}}>
      <input
        type="checkbox"
        checked={productAccess.lms}
        onChange={(e)=>setProductAccess(prev=>({...prev,lms:e.target.checked}))}
        style={productCheckbox}
      />
      <div>
        <strong style={{display:"block",marginBottom:"4px"}}>MaAz LMS</strong>
        <span style={productDescription}>Courses, modules, lessons and recordings</span>
      </div>
      <span style={productStatus(productAccess.lms)}>{productAccess.lms ? "Enabled" : "Disabled"}</span>
    </label>

    <label style={{...productAccessOption,...(productAccess.live ? productAccessOptionActive : {})}}>
      <input
        type="checkbox"
        checked={productAccess.live}
        onChange={(e)=>setProductAccess(prev=>({...prev,live:e.target.checked}))}
        style={productCheckbox}
      />
      <div>
        <strong style={{display:"block",marginBottom:"4px"}}>MaAz Live</strong>
        <span style={productDescription}>Join scheduled MaAz Live classroom sessions</span>
      </div>
      <span style={productStatus(productAccess.live)}>{productAccess.live ? "Enabled" : "Disabled"}</span>
    </label>

  </div>
)}

</div>


{/* BATCH SECTION */}

<div style={card}>

<h3>Batch Numbers</h3>

{batches.map((batch,index)=>(

<div key={index} style={{display:"flex",marginBottom:"10px"}}>

<input
value={batch}
placeholder="Batch Number"
onChange={(e)=>updateBatch(index,e.target.value)}
style={{...input,flex:1,marginBottom:"0"}}
/>

{index !== 0 && (

<button
type="button"
onClick={()=>removeBatch(index)}
style={dangerBtn}
>
Remove
</button>

)}

</div>

))}

<button
type="button"
onClick={addBatch}
style={blueBtn}
>
+ Add Batch
</button>

</div>


{/* COURSE ACCESS */}

<div style={card}>

<h3>Course Access</h3>

<select
value={selectedIndex}
onChange={(e)=>setSelectedIndex(parseInt(e.target.value))}
style={input}
>

{courseAccess.map((access,index)=>{

const course = courses.find(c=>c.id===access.course_id);

return(
<option key={index} value={index}>
{course ? course.title : "New Course"}
</option>
)

})}

</select>

{currentAccess && (

<div style={accessCard}>

<select
value={currentAccess.course_id}
onChange={(e)=>updateCourseAccess(selectedIndex,"course_id", e.target.value)}
disabled={!currentAccess.isNew}
style={{...input, appearance:"none", WebkitAppearance:"none", MozAppearance:"none", background:"#f5f5f5"}}
style={{
    ...input,
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    background: currentAccess.isNew ? "#fff" : "#f5f5f5"
}}
>

<option value="">Select New Course to Add</option>

{courses
    .filter(c => {
      const assignedCourseIds = courseAccess
        .filter((item, index) => index !== selectedIndex && item.course_id)
        .map(item => item.course_id);

      return !assignedCourseIds.includes(c.id) || c.id === currentAccess.course_id;
    })
    .map(c => (
      <option key={c.id} value={c.id}>
        {c.title}
      </option>
    ))}

</select>

<select
value={currentAccess.access_type}
onChange={(e)=>updateCourseAccess(selectedIndex,"access_type",e.target.value)}
style={input}
>

<option value="full">Complete Access</option>
<option value="partial">Partial Access</option>

</select>

{/* NEW STREAM SOURCE */}

<select
value={currentAccess.video_source || "maaz"}
onChange={(e)=>updateCourseAccess(selectedIndex,"video_source",e.target.value)}
style={input}
>
<option value="maaz">MaAz Secure Stream</option>
<option value="bunny">Bunny CDN Secure Stream</option>
</select>

<select
value={currentAccess.status}
onChange={(e)=>updateCourseAccess(selectedIndex,"status",e.target.value)}
style={input}
>

<option value="active">Active</option>
<option value="inactive">Inactive</option>

</select>

{currentAccess.access_type==="partial" && currentAccess.course_id && (

<div style={{marginBottom:"10px"}}>

<strong>Select Modules</strong>

{getModulesForCourse(currentAccess.course_id).map(module=>(

<div key={module.id}>

<label>

<input
type="checkbox"
checked={(currentAccess.module_ids || []).includes(module.id)}
onChange={()=>toggleModule(module.id)}
/>

{" "}{module.title}

</label>

</div>

))}

</div>

)}
  
<input
type="date"
required
value={currentAccess.start_date || ""}
onChange={(e)=>updateCourseAccess(selectedIndex,"start_date",e.target.value)}
style={input}
/>

<input
type="date"
required
value={currentAccess.end_date || ""}
onChange={(e)=>updateCourseAccess(selectedIndex,"end_date",e.target.value)}
style={input}
/>
{/* 🔥 DELETE BUTTON HERE */}
{/* 🔥 DELETE BUTTON HERE */}
<button
  type="button"
  //onClick={() => removeCourseAccess(selectedIndex)}
onClick={() => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this course access?"
    );

    if (confirmDelete) {
      removeCourseAccess(selectedIndex);
    }
  }}
  style={{
    background: "#e74c3c",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    marginTop: "10px"
  }}
>
  Delete Course Access
</button>


</div>

)}

<button onClick={addCourseAccess} style={blueBtn}>
+ Add Course Access
</button>

</div>


{/* ACTION BUTTONS */}

<div style={{marginTop:"20px"}}>

<button style={primaryBtn} onClick={saveStudent}>
Save Changes
</button>

<button
style={cancelBtn}
onClick={()=>setPage({page:"students"})}
>
Cancel
</button>

</div>

</div>

)

}

const card={
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"25px"
};

const accessCard={
border:"1px solid #eee",
padding:"15px",
borderRadius:"6px",
background:"#fafafa"
};

const input={
width:"100%",
padding:"10px",
marginBottom:"12px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const primaryBtn={
background:"#2c3e50",
color:"white",
padding:"10px 18px",
border:"none",
borderRadius:"6px",
marginRight:"10px",
cursor:"pointer"
};

const cancelBtn={
padding:"10px 18px",
borderRadius:"6px",
border:"1px solid #ccc",
cursor:"pointer"
};

const blueBtn={
background:"#3498db",
color:"white",
border:"none",
padding:"8px 14px",
borderRadius:"6px",
cursor:"pointer",
marginTop:"10px"
};

const dangerBtn={
marginLeft:"10px",
background:"#e74c3c",
color:"white",
border:"none",
padding:"8px 12px",
borderRadius:"6px",
cursor:"pointer"
};

const productAccessGrid={
display:"grid",
gridTemplateColumns:"repeat(2,minmax(0,1fr))",
gap:"14px"
};

const productAccessOption={
display:"grid",
gridTemplateColumns:"auto 1fr auto",
alignItems:"center",
gap:"12px",
padding:"16px",
border:"1px solid #e5e7eb",
borderRadius:"10px",
background:"#fafafa",
cursor:"pointer"
};

const productAccessOptionActive={
border:"1px solid #d71920",
background:"#fff7f7"
};

const productCheckbox={
width:"18px",
height:"18px",
accentColor:"#d71920"
};

const productDescription={
fontSize:"12px",
color:"#667085",
lineHeight:"1.45"
};

const productStatus=(enabled)=>({
fontSize:"11px",
fontWeight:"700",
padding:"5px 8px",
borderRadius:"999px",
color:enabled ? "#16794b" : "#667085",
background:enabled ? "#eaf8f1" : "#eef0f2"
});

export default EditStudent;
